namespace Matrix.Data {
    export interface SettingsRow {
        Key?: string;
        Value?: any;
        Description?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace SettingsRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'Key';
        export const localTextPrefix = 'Data.Settings';
        export const deletePermission = 'DataAdmin:Settings';
        export const insertPermission = 'DataAdmin:Settings';
        export const readPermission = 'Read:Settings';
        export const updatePermission = 'DataAdmin:Settings';

        export declare const enum Fields {
            Key = "Key",
            Value = "Value",
            Description = "Description",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
